define('GameDayCore/GDModel/ValueObjects/RealTimeHighlights/RealTimeHighlightsUrl',['require','exports','module','../ValueObjectFactory'],function(require, exports, module) {
	var VO = require('../ValueObjectFactory');

	VO.create(RealTimeHighlightsUrl);

	function RealTimeHighlightsUrl($data) {
		var vo = VO.ensureVO(this, RealTimeHighlightsUrl),
			data = $data;

	    vo.playback_scenario = data["playback-scenario"] || data.playback_scenario || "";
	    vo.id = data.id || "";
	    vo.authorization = data.authorization || null;
	    vo.login = data.login || null;
	    vo.mid = data.mid || null;
	    vo.cat_code = data.cat_code || "";
	    vo.state = data.state || "";
	    vo.url = data._text || "";

	}

	return RealTimeHighlightsUrl;
});
